import { render, staticRenderFns } from "./InputBoxDlg.vue?vue&type=template&id=5579291e"
import script from "./InputBoxDlg.vue?vue&type=script&lang=js"
export * from "./InputBoxDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports